// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RDau","title":"Header_title__lKq9q","left":"Header_left__34zfr","clinicName":"Header_clinicName__3KDNW"};